import { render, staticRenderFns } from "./InlineIngredients.vue?vue&type=template&id=a4d8534c&scoped=true"
import script from "./InlineIngredients.vue?vue&type=script&lang=js"
export * from "./InlineIngredients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d8534c",
  null
  
)

export default component.exports